import React, { FC, useEffect, useRef, useState } from "react";
import styles from './select-language.module.scss'
import { useLocation, useSearchParams } from "react-router-dom";
import i18n from '../../../i18n';

interface Language {
    culture: string,
    name: string,
    display: string[]
}

const SelectLanguage: FC = () => {
    const languages: Language[]  = [{
        culture: 'en',
        name: 'English',
        display: ['English','إنجليزي']
    },{
        culture: 'ar',
        name: 'العربية',
        display: ['Arabic','العربية']
    }];
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [language, setLanguage] = useState<Language>(languages[0])
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    
    useEffect(() => {
        const currentLang = languages.find(l => l.culture === i18n.language) || languages[0];
        setLanguage(currentLang);
    }, []);

    useEffect(() => {
        const currentLang = searchParams.get("lang");
        const isDefault = language.culture === "en";
        if (isDefault) {
            if (currentLang) {
                setSearchParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.delete("lang");
                    return newParams;
                }, { replace: true });
            }
            return;
        }

        if (currentLang !== language.culture) {
            setSearchParams((prev) => {
                const newParams = new URLSearchParams(prev);
                newParams.set("lang", language.culture);
                return newParams;
            }, { replace: true });
        }
    }, [language, searchParams, setSearchParams, location.pathname]);
    
    const ref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | Event) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
            setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleCard = () => {
        setIsOpen(prev => !prev);
    };
    const handleSelectLanguage = (lang: Language) => {
        if (lang.culture === language.culture) return;
        i18n.changeLanguage(lang.culture);
        setLanguage(lang);
        setIsOpen(false);
    }
    return (
        <div className={styles.selectLanguage} ref={ref}>
            <button onClick={toggleCard} className={isOpen ? styles.open : ''}>
                <div className={styles.select}>
                    <div className={styles.language}/>
                    {language.name}
                </div>
                <div className={styles.chevron}/>
            </button>
            {
                isOpen && 
                <ul className={styles.popup}>
                    {
                        languages.map((lang, idx) => (
                            <li key={idx} 
                            className={`${styles.langItem} ${lang.culture === language.culture ? styles.current : ''}`}
                            onClick={()=> handleSelectLanguage(lang)}>
                                {lang.display.map((name, id)=> (<span key={id}>{name}</span>))}
                            </li>
                        ))
                    }
                </ul>
            }
            
            </div>
    )
}

export default SelectLanguage
